import { useContext } from 'react';
import useSWR from 'swr';
import { UseSWRQueryResult } from '../../common/types/swrTypes';
import { deleteToApi, getFromApi, postToApi } from '../../common/utils/apiHelper';
import { ConfigContext } from '../configuration/ConfigContext';
import { usePropertyAssociationContext } from '../propertyAssociation/PropertyAssociationContext';
import { AddAssetsToGroupRequest } from './models/AddAssetsToGroupRequest';
import { CreateAssetGroupRequest } from './models/CreateAssetGroupRequest';
import { GetAssetGroupResponse, GetAssetGroupsResponse } from './models/GetAssetGroupsResponse';
import { RemoveAssetsFromGroupRequest } from './models/RemoveAssetsFromGroupRequest';

type UseAssetGroupResult = UseSWRQueryResult<GetAssetGroupResponse, 'assetGroup'>;

export const useAssetGroup = (assetGroupId: string | undefined): UseAssetGroupResult => {
    const { apiBaseUrl } = useContext(ConfigContext);
    const { currentPropertyAssociation } = usePropertyAssociationContext();

    const url =
        assetGroupId && currentPropertyAssociation?.propertyAssociationId ? `${apiBaseUrl}/propertyassociations/${currentPropertyAssociation.propertyAssociationId}/assetgroups/${assetGroupId}` : null;

    const { data, error, isLoading } = useSWR<GetAssetGroupResponse>(url);

    return {
        assetGroup: data,
        isLoading,
        error,
    };
};

export const getAssetGroups = (apiBaseUrl: string, propertyAssociationId: string, onSuccess: (response: GetAssetGroupsResponse) => void, onError: () => void): void => {
    getFromApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/assetgroups`, onSuccess, onError);
};

export const createAssetGroup = (apiBaseUrl: string, propertyAssociationId: string, data: CreateAssetGroupRequest, onSuccess: (assetGroupId: string) => void, onError: () => void): void => {
    postToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/assetgroups`, data, onSuccess, onError);
};

export const deleteAssetGroup = (apiBaseUrl: string, propertyAssociationId: string, assetGroupId: string, onSuccess: () => void, onError: () => void): void => {
    deleteToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/assetgroups/${assetGroupId}`, onSuccess, onError);
};

export const addAssetToAssetGroup = (apiBaseUrl: string, propertyAssociationId: string, assetGroupId: string, data: AddAssetsToGroupRequest, onSuccess: () => void, onError: () => void): void => {
    postToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/assetgroups/${assetGroupId}/add`, data, onSuccess, onError);
};

export const removeAssetFromAssetGroup = (
    apiBaseUrl: string,
    propertyAssociationId: string,
    assetGroupId: string,
    data: RemoveAssetsFromGroupRequest,
    onSuccess: () => void,
    onError: () => void,
): void => {
    postToApi(`${apiBaseUrl}/propertyassociations/${propertyAssociationId}/assetgroups/${assetGroupId}/remove`, data, onSuccess, onError);
};
